<template>
  <v-dialog v-model="showModal" max-width="800px">
    <v-card>
      <v-card-title>

      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex
              xs12 class="text-xs-center"
              v-html="checkCompany(payload.senderCompany)">
            </v-flex>
            <v-flex
              xs12 class="text-xs-center"
              v-html="checkPhone(payload.phone)">
            </v-flex>
            <v-flex
              xs12 class="text-xs-center"
              v-html="checkJobTitle(payload.senderJobTitle)">
            </v-flex>
            <v-flex
              xs12 class="text-xs-center"
              v-html="attendeeData">
            </v-flex>
            <v-flex
              xs12 class="text-xs-center"
              v-html="checkInterestType(payload.interestType)">
            </v-flex>
            <v-flex
              xs12 class="text-xs-center"
              v-html="checkMessage(payload.message)">
            </v-flex>
            <v-flex xs12 class="text-xs-center py-2">
              <v-btn
                color="blue darken-1"
                flat="flat"
                @click="closeModal"
              >
                close
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ModalMessagesInfo',
    props: {
      isShow: {
        default: false,
        required: true,
        type: Boolean
      },
      payload: {
        required: true,
        type: Object
      }
    },
    data () {
      return {
        showModal: false,
        attendeeData: ''
      }
    },
    watch: {
      show: {
        handler () {
          this.showModal = this.isShow
        },
        immediate: true,
      },
      showModal (val) {
        if (!val) this.closeModal()
      }
    },
    methods: {
      checkCompany (val) {
        if (val) return `<strong>Company:</strong> ${val}`
      },
      checkPhone (val) {
        if (val) return `<strong>Phone:</strong> ${val}`
      },
      checkJobTitle (val) {
        if (val) return `<strong>Job Title:</strong> ${val}`
      },
      checkSenderId (senderId, receiverId) {
        if (senderId && receiverId) {
          return this.attendeeId(senderId, receiverId)
        }
        else {
          return ''
        }
      },
      async attendeeId (senderId, receiverId) {
        try {
          const sender = await this.$store.dispatch('fetchAllAttendee', { filter: { id: senderId } })
          const receiver = await this.$store.dispatch('fetchAllAttendee', { filter: { id: receiverId } })
          const senderData = sender.attendees.length === 1
            ? `${sender.attendees[0].firstName} ${sender.attendees[0].lastName} ( ${sender.attendees[0].email} )`
            : this.payload.email
          const receiverData = receiver.attendees.length === 1
            ? `${receiver.attendees[0].firstName} ${receiver.attendees[0].lastName} ( email: ${receiver.attendees[0].email})`
            : this.payload.receiverEmail
          this.attendeeData = `Message sender <strong>${senderData}</strong> to receiver <strong>${receiverData}</strong>`
        } catch (err) {
          console.log(err)
        }
      },
      getInterestTitle(val) {
        if (val === 'Sponsorship') return 'Become a sponsor'
        if (val === 'Reserved') return 'Reserve a table'
        return 'None'
      },
      checkInterestType (val) {
        if (val) return `<strong>Interested in:</strong> ${this.getInterestTitle(val)}`
      },
      checkMessage (val) {
        if (val) return `<strong>Message:</strong> ${val}`
      },
      closeModal () {
        this.$emit('close')
      }
    },
    created () {
      this.checkSenderId(this.payload.senderId, this.payload.receiverId)
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/pages/AttendeesMessages/modalAttendee.vue